'use client'

import { useTranslation } from '@shared/config/i18n'

import { BottomSheetTrigger, Checkbox, HStack, Line24pxForwardIcon, Typography } from '@podo-app/design-system-temp'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
}

const PaymentTermsAgree = ({ checked, onChange }: Props) => {
  const t = useTranslation()

  return (
    <HStack
      className="min-h-[52px] items-center border border-gray-200 rounded-lg px-4 py-2 gap-4 cursor-pointer"
      onClick={() => onChange(!checked)}
    >
      <Checkbox checked={checked} />
      <Typography size="body1" className="flex-1">
        {t('payment.terms.agree')}
      </Typography>

      <BottomSheetTrigger onClick={(event) => event.stopPropagation()}>
        <Line24pxForwardIcon className="text-gray-500" />
      </BottomSheetTrigger>
    </HStack>
  )
}

export default PaymentTermsAgree
